import { IdentityDto } from './identity.dto';

export class ContactDto {
  identity = new IdentityDto();
  contactType: string;
  phoneNumber: string;
  webSite?: string;

  constructor(d?: ContactDto) {
    if (!d) {
      return;
    }

    this.identity = new IdentityDto(d.identity);
    this.contactType = d.contactType;
    this.phoneNumber = d.phoneNumber;
    this.webSite = d.webSite;
  }
}
